<template>
  <div v-circular-tab class="ui-drawer-body" :class="contentClasses">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

type Props = {
  flat?: boolean
}

const props = defineProps<Props>()

const contentClasses = computed(() => ({
  ['ui-drawer-body--flat']: props.flat
}))
</script>

<style>
.ui-drawer-body {
  @apply pt-4 pb-4 px-default gap-4;
  @apply flex flex-col flex-auto;
  @apply overflow-y-auto;

  &--flat {
    @apply p-0 gap-0;
  }
}
</style>
